import React from 'react';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Grid from '@material-ui/core/Grid';
import styled from 'styled-components';
import ReactHtmlParser from 'react-html-parser';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';

const QuestionItemContainer = styled.div`
  padding: 16px;
  padding-bottom: 12px;
  background-color: var(--white);
  margin: 4px 0;
  border-radius: 4px;
  border: 1px solid var(--lightbg);
  cursor: pointer;
`;

const QuestionText = styled.div`
  color: var(--primary-light);
`;

const QuestionContent = styled(Grid)`
  padding-top: 8px;
`;

const CustomTableCell = styled(TableCell)`
  color: var(--primary-light) !important;
`;

const QuestionItem = ({title, content, isTable = false, headers = [], data = []}) => {

  const [open, setOpen] = React.useState(false);

  return(
    <QuestionItemContainer>
      <div>
        <Grid container>
          <Grid xs={11} item>
            <QuestionText onClick={() => setOpen(!open)}>
              {title}
            </QuestionText>
          </Grid>
          <Grid xs={1} item>
            <div onClick={() => setOpen(!open)} style={{ textAlign:"right" }} >
              {open && <ArrowDropUpIcon />}
              {!open && <ArrowDropDownIcon />}
            </div>
          </Grid>
          {open && !isTable && (
            <QuestionContent xs={12} item>
              <QuestionText>{ReactHtmlParser(content)}</QuestionText>
            </QuestionContent>
          )}
          {
            open && isTable && headers.length > 0 && data.length > 0 && (
            <QuestionContent xs={12} item>
              <QuestionText>
                {ReactHtmlParser(content)}
                <TableContainer component={Paper} style={{ marginTop: 16 }}>
                  <Table size="small" aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        {
                          headers.map((header) => (
                            <CustomTableCell
                              className="bold-text"
                              key={ "title" + Math.random() }
                              style={{ backgroundColor: "var(--lightbg)", width: "100%" }}
                            >
                              {header}
                            </CustomTableCell>
                          ))
                        }
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {
                        data.map((line, index) => (
                          <TableRow key={Math.random() + index}>
                            { (Object.keys(data[index]).map((cell, index) => (
                            <TableCell
                              key={`cell${index + Math.random()}`}
                              align="left"
                              className="primary-light--text"
                            >
                              {line[cell]}
                            </TableCell>
                          )))}
                          </TableRow>
                        ))
                      }
                    </TableBody>
                  </Table>
                </TableContainer>
              </QuestionText>
            </QuestionContent>
            )
          }
        </Grid>
      </div>
    </QuestionItemContainer>
  );
}

export default QuestionItem;